import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'MG',
  name: 'Marcela G.',
  province: 'Córdoba',
  stars: 5,
  text: 'Llevaba años con dolores que ningún médico podía explicar. En la primera semana de estudio entendí el origen emocional de todo. El Tomo II — El Mapa del Síntoma — cambió mi vida.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  province: 'Rosario',
  stars: 5,
  text: 'El material más completo que vi en español sobre biodescodificación. Los protocolos de sesión están enmarcados en mi consultorio y mis clientes los ven apenas entran.'
}, {
  initials: 'RM',
  name: 'Romina M.',
  province: 'Buenos Aires',
  stars: 5,
  text: 'Ya hacía terapia floral hace años. El MegaPack completó todo lo que me faltaba. Ahora tengo lista de espera en mi consultorio.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-290">
      {Array.from({
      length: count
    }).map((_, i) => <span key={i} className="text-[#eab308] text-sm" data-id="element-291">
          ⭐
        </span>)}
    </div>;
}
function TestimonialCard({
  initials,
  name,
  province,
  stars,
  text,
  index
}: {
  initials: string;
  name: string;
  province: string;
  stars: number;
  text: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-[#111111] border border-white/10 rounded-xl p-5 sm:p-6 flex flex-col gap-3 transition-all duration-500 hover:border-[#eab308]/30 hover:shadow-[0_0_20px_rgba(234,179,8,0.08)] ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-292">
      <div className="flex items-center justify-between mb-1" data-id="element-293">
        <div className="flex items-center gap-2" data-id="element-294">
          <div className="w-8 h-8 rounded-full bg-[#eab308]/15 border border-[#eab308]/25 flex items-center justify-center flex-shrink-0" data-id="element-295">
            <span className="text-[#eab308] font-bold text-xs" data-id="element-296">{initials}</span>
          </div>
          <StarRating count={stars} data-id="element-297" />
        </div>
      </div>
      <p className="text-gray-300 text-sm sm:text-base leading-relaxed flex-grow italic" data-id="element-298">
        "{text}"
      </p>
      <div className="pt-2 border-t border-white/5" data-id="element-299">
        <p className="text-white text-sm font-semibold" data-id="element-300">
          {name} — {province}
        </p>
      </div>
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-[#0a0a0a] py-10 md:py-12 px-4 sm:px-6 border-t border-white/5" data-id="element-301">
      <div className="container mx-auto max-w-5xl" data-id="element-302">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-303">
          {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-304" />)}
        </div>
      </div>
    </section>;
}